// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KZrn","colBig":"styles_colBig__z69-X","colSmall":"styles_colSmall__2iQyY"};